import axios from '../http-config/axiosConfig';

const EmailSettingsApi = {
  getSettingsAsync: async () => {
    const { data } = await axios.get('/Admin/Email/GetSettings');
    return data.result;
  },

  updateSettingsAsync: async (updatedSettings, username) => {
    const appName = 'Integrator Client';

    // If we add logging in more endpoints, this should be moved to axios configuration instead.
    const { data } = await axios.put('/Admin/Email/UpdateSettings', updatedSettings, {
      headers: {
        'X-UserName-Hint': username,
        'X-AppName-Hint': appName
      }
    });

    if (!data.isSuccess) {
      throw new Error(data.message);
    }
    return data.result;
  },

  getAllExchangeAccountsAsync: async () => {
    const { data } = await axios.get('/Admin/Email/GetAllExchangeAccounts');
    return data.result;
  },

  runBulkEmailProcessingAsync: async () => {
    const { data } = await axios.post('/Admin/Email/RunBulkEmailProcessing');
    return data.result;
  }
};

export default EmailSettingsApi;
